import dayjs from "dayjs";
import { TFunction } from "i18next";
import { NavigateFunction } from "react-router";
import { alertCategoryConfig } from "./Alerts/alertCategoryConfig/AlertCategoryConfig";
import { notificationCategoryConfig } from "./Notifications/NotificationCategoryConfig/NotificationCategoryConfig";
import {
  AlertsAndNotification,
  AppNotificationContextValues,
} from "../../../../../../context/AppNotificationContext/AppNotificationContext";
import { CATEGORY_MAP } from "../../../../../../pages/alertAndNotifications/list/constants";
import { dayJSLang } from "../../../../../../types";

export function mapAlertListItems(
  alerts: AlertsAndNotification[],
  language: string,
  t: TFunction,
  isMultipleAccountViewActive: boolean,
  navigate: NavigateFunction,
  markAlertsAsRead?: AppNotificationContextValues["markAlertsAsRead"]
) {
  return alerts.map((alert) => {
    const id = alert.id.split("#")[0];
    const mappedCategory = CATEGORY_MAP[alert.type];
    const config = alertCategoryConfig[mappedCategory];
    return {
      id,
      heading: config?.getHeading(alert, t, isMultipleAccountViewActive),
      message: config?.getMessage(alert, t),
      date: formatDate(alert.createdAt, language),
      isRead: alert.isRead,
      buttonText: config?.getButtonText(t),
      onButtonClick: () =>
        config?.onButtonClick(alert, navigate, markAlertsAsRead),
      icon: config?.getIcon?.(),
    };
  });
}

export function mapAppNotificationListItem(
  notification: AlertsAndNotification,
  language: string,
  t: TFunction,
  isMultipleAccountViewActive: boolean,
  navigate: NavigateFunction,
  markNotificationAsRead: (
    notificationsToMarkAsRead: { id: string; source: string }[]
  ) => void,
  enableDelegateLogin = false
) {
  const mappedCategory = CATEGORY_MAP[notification.type];
  const config = notificationCategoryConfig[mappedCategory];

  return {
    id: notification.id,
    heading: config?.getHeading(notification, t, isMultipleAccountViewActive),
    message: config?.getMessage(notification, t),
    iconBadge: config?.getIconBadge(),
    date: formatDate(notification.createdAt, language),
    isRead: notification.isRead,
    buttonText: config?.getButtonText(t),
    onButtonClick: () =>
      config?.onButtonClick(
        notification,
        navigate,
        markNotificationAsRead,
        enableDelegateLogin
      ),
  };
}

function formatDate(dateString: string, language: string): string {
  return dayjs(dateString).locale(dayJSLang[language]).format("DD-MMM-YYYY");
}
